var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_418_5990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_418_5990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 20.5C12.2871 20.5 12.109 20.4281 11.9655 20.2843C11.8218 20.1406 11.75 19.9625 11.75 19.75V12.75H4.75C4.5375 12.75 4.35942 12.6781 4.21575 12.5343C4.07192 12.3904 4 12.2122 4 11.9998C4 11.7871 4.07192 11.609 4.21575 11.4655C4.35942 11.3218 4.5375 11.25 4.75 11.25H11.75V4.25C11.75 4.0375 11.8219 3.85942 11.9658 3.71575C12.1096 3.57192 12.2878 3.5 12.5003 3.5C12.7129 3.5 12.891 3.57192 13.0345 3.71575C13.1782 3.85942 13.25 4.0375 13.25 4.25V11.25H20.25C20.4625 11.25 20.6406 11.3219 20.7843 11.4658C20.9281 11.6096 21 11.7878 21 12.0003C21 12.2129 20.9281 12.391 20.7843 12.5345C20.6406 12.6782 20.4625 12.75 20.25 12.75H13.25V19.75C13.25 19.9625 13.1781 20.1406 13.0343 20.2843C12.8904 20.4281 12.7122 20.5 12.4998 20.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.234de648e4ffe3360d84502aefed892f.svg";
export { ForwardRef as ReactComponent };